import { Button, Grid, Stack } from "@mui/material";
import Spinner from "components/spinner";
import AlignmentToolIcon from "./images/complete.png";
import styled from "styled-components";
import Launch from "@mui/icons-material/Launch";
import Replay from "@mui/icons-material/Replay";
import { NumberParam, useQueryParams } from "use-query-params";
import { useSelector } from "react-redux";
import { IState } from "store/types";
import { useCallback } from "react";
import { navigate } from "@reach/router";
import { requiredEnvVar } from "lib/envUtil";
import { getCurrentSubjectName } from "lib/currentSubject";

const PageTitle = styled.h2`
  margin-top: 0.5rem;
  margin-bottom: 0rem;
  letter-spacing: -1px;
  align-items: center;
  text-align: center;
`;

const PageDescription = styled.p`
  margin-top: 1rem;
  margin-bottom: 0rem;
  align-items: center;
  text-align: center;
`;

const NewButton = styled(Button)`
  margin-top: 1rem;
`;

export const AlignmentSuccessPage = () => {
  // Query parameters
  const [query, _setQuery] = useQueryParams({
    subjectId: NumberParam,
  });

  // What we need from Redux
  const submittingChanges = useSelector((state: IState) => state.submittingChanges);
  const subjectName = getCurrentSubjectName(query.subjectId);

  const onNewButtonClick = useCallback(() => {
    navigate(`/wizardStepOne`);
  }, []);

  const lmsHome = requiredEnvVar("LMS_HOME");

  if (submittingChanges) {
    return <Spinner loading={submittingChanges} />;
  } else
    return (
      <Stack>
        <img
          src={AlignmentToolIcon}
          style={{ alignSelf: "center", paddingTop: "72px", paddingBottom: "16px" }}
          width="252"
          height="168"
          alt="LMSMorph icon"
        />
        <PageTitle>
          {subjectName}
          <br /> has been submitted for alignment.
          <br />
          This process can take a few minutes.
        </PageTitle>
        <PageDescription>You can edit the content of this subject in</PageDescription>
        <Grid
          tabIndex={-1}
          item
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Button href={lmsHome} target="_blank" endIcon={<Launch />}>
            LMS Admin
          </Button>
        </Grid>
        <Grid
          tabIndex={-1}
          item
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <NewButton startIcon={<Replay />} variant="contained" onClick={onNewButtonClick}>
            Align another subject
          </NewButton>
        </Grid>
      </Stack>
    );
};
